import { useState, useContext, useEffect } 	from "react";
import { Link } from "react-router-dom";
import { Card, CardContent,  Stack, Typography } from "@mui/material"
import { DataGrid } from "@mui/x-data-grid";

import { formatCurrency } 	from "../../../common/Helper";
import useBreakpoint		from "../../../hooks/useBreakpoint"
import DashboardContext 	from "../context";

import LoadingCard 			from "./LoadingCard";

const AssetListCard = (props) => {

	const {portfolio} 					= useContext(DashboardContext)
	const [assetList, setAssetList]		= useState()
	const [total, setTotal]				= useState()

	const currentBreakpoint				= useBreakpoint()

	useEffect(() => {
		if (portfolio) {
			let filteredPortfolio = portfolio.filter(p => p.assetType === props.assetType)
			
			setTotal(filteredPortfolio.reduce((acc, fp) => acc + parseFloat(fp.currentValue), 0))
			setAssetList(filteredPortfolio)
		}	
	}, [portfolio])

	if (!portfolio) {
		return (
			<LoadingCard/>
		)
	}

	let columns = [
		{ 
			field: 'identificator', 
			headerName: 'Ticker', 
			renderCell: (cellValues) => {	
				return <Link to={`/company/${cellValues.row.identificator}`} target="_blank">{cellValues.row.identificator}</Link>;
			},
			sortComparator : (v1, v2) => v1.localeCompare(v2),
			disableColumnMenu : true,
			width:40,
			flex: 1
		},
		{ 
			field: 'quantity', 
			headerName: 'Qtd', 
			renderCell: (cellValues) => {	
				return parseFloat(cellValues.row.quantity).toFixed(0)
			},
			sortComparator : (v1, v2) => parseFloat(v1) - parseFloat(v2),
			disableColumnMenu : true,
			width:40,
			flex: 0,
			align:'center',
			headerAlign:'center'
		},
		{ 
			field: 'cost', 
			headerName: 'Custo', 
			renderCell: (cellValues) => {	
				return formatCurrency(cellValues.row.cost)
			},
			sortComparator : (v1, v2) => parseFloat(v1) - parseFloat(v2),
			disableColumnMenu : true,
			width:80,
			flex: 1
		},		
		{ 
			field: 'currentValue', 
			headerName: 'Valor', 
			renderCell: (cellValues) => {	
				return formatCurrency(cellValues.row.currentValue)
			},
			sortComparator : (v1, v2) => parseFloat(v1) - parseFloat(v2),
			disableColumnMenu : true,
			width:80,
			flex: 1
		},	
		{ 
			field: 'avgPrice', 
			headerName: 'Preço Médio', 
			renderCell: (cellValues) => {	
				return formatCurrency(cellValues.row.avgPrice, 'SMALL')
			},
			sortComparator : (v1, v2) => parseFloat(v1) - parseFloat(v2),
			disableColumnMenu : true,
			width:80,
			flex: 1,
			align:'center',
			headerAlign:'center'
		},
		{ 
			field: 'price', 
			headerName: 'Preço', 
			renderCell: (cellValues) => {	
				return formatCurrency(cellValues.row.price, 'SMALL')
			},
			sortComparator : (v1, v2) => parseFloat(v1) - parseFloat(v2),
			disableColumnMenu : true,
			width:80,
			flex: 1,
			align:'center',
			headerAlign:'center'
		},
		{ 
			field: 'return', 
			headerName: '% Geral', 
			renderCell: (cellValues) => {	
				return cellValues.row.return.toFixed(2) +' %'
			},
			cellClassName : (cellValues) => cellValues.value < 0 ? 'super-app negative' : 'super-app positive', 
			sortComparator : (v1, v2) => parseFloat(v1) - parseFloat(v2),
			disableColumnMenu : true,
			width:80,
			flex: 1,
			align:'center',
			headerAlign:'center'
		},
		{ 
			field: 'changePercent', 
			headerName: '% Hoje', 
			renderCell: (cellValues) => {	
				return parseFloat(cellValues.row.changePercent).toFixed(2) +' %'
			},
			cellClassName : (cellValues) => cellValues.value < 0 ? 'super-app negative' : 'super-app positive', 
			sortComparator : (v1, v2) => parseFloat(v1) - parseFloat(v2),
			disableColumnMenu : true,
			width:80,
			flex: 1,
			align:'center',
			headerAlign:'center'
		},
		{ 
			field : 'share',
			headerName: 'Share', 
			valueGetter: (cellValues, row) => ((row.currentValue/total)*100),
			renderCell: (cellValues) => {	
				return ((cellValues.row.currentValue/total)*100).toFixed(2) +' %'
			},			
			sortComparator : (v1, v2) => parseFloat(v1) - parseFloat(v2),
			disableColumnMenu : true,
			width:80,
			flex: 1,
			align:'center',
			headerAlign:'center'
		},
		{ 
			field: 'dividends', 
			headerName: 'Dividendos', 
			renderCell: (cellValues) => {	
				return formatCurrency(cellValues.row.dividends || 0)
			},
			sortComparator : (v1, v2) => parseFloat(v1) - parseFloat(v2),
			disableColumnMenu : true,
			width:120,
			flex: 1
		},		
	]

	const removeObjects = (pArray, pObjects) => {
		let currentArray = pArray
		pObjects.map(o => {
			const currentIndex = currentArray.findIndex(a => a.field === o)
			if (currentIndex) currentArray.splice(currentIndex, 1)
		})

		return pArray
	}

	if ( currentBreakpoint() === 'xs') {
		columns = removeObjects(columns, ['cost', 'avgPrice', 'dividends', 'share'])
	}


	return (
		<Card sx={{height: '100%'}}>
			<CardContent>
				<Stack direction={'column'} spacing={1}>
					<Typography variant="h6" fontWeight={'bold'}>{props.title}</Typography>
					{ assetList ? (
					<DataGrid
						getRowId={(row) => row.identificator} 
						rows={assetList}
						columns={columns}
						rowHeight={30}
						hideFooter
						sx={{
							fontSize	: '0.65rem',
							height		: '100%',
							width		: '100%',
							'& .super-app.negative': {
								color: '#FF0000', 
								fontWeight: '400',
							},
							'& .super-app.positive': {
								color: '#008000',
								fontWeight: '400',
							},
						}} 						
					/>
					) : (
						null
					)}
					{/* <TableContainer component={Paper}>
						<Table size="small">
							<TableHead >
								<TableRow>
									<TableCell sx={{fontSize: '0.65rem', fontWeight: '700'}}> Ticker </TableCell>
									<TableCell sx={{fontSize: '0.65rem', fontWeight: '700'}} align="left"> Qtd </TableCell>
									<TableCell sx={{fontSize: '0.65rem', fontWeight: '700'}} align="left"> Original </TableCell>
									<TableCell sx={{fontSize: '0.65rem', fontWeight: '700'}} align="center"> Atual </TableCell>
									<TableCell sx={{fontSize: '0.65rem', fontWeight: '700'}} align="center"> Preço Medio </TableCell>
									<TableCell sx={{fontSize: '0.65rem', fontWeight: '700'}} align="center"> Preço </TableCell>
									<TableCell sx={{fontSize: '0.65rem', fontWeight: '700'}} align="center"> % Geral </TableCell>
									<TableCell sx={{fontSize: '0.65rem', fontWeight: '700'}} align="center"> % Hoje </TableCell>
									<TableCell sx={{fontSize: '0.65rem', fontWeight: '700'}} align="center"> % Portfolio </TableCell>
									<TableCell sx={{fontSize: '0.65rem', fontWeight: '700'}} align="center"> Dividendos </TableCell>
								</TableRow>
							</TableHead>

							<TableBody>
								{ assetList ? assetList.map((asset) => (
									<TableRow key={"key_"+ asset.identificator}>
										<TableCell sx={{ fontSize: '0.65rem'}}><Link to={'/company/'+ asset.identificator} target="_blank">{asset.identificator}</Link></TableCell>
										<TableCell sx={{ fontSize: '0.65rem'}} align="left">{parseFloat(asset.quantity).toFixed(0)}</TableCell>
										<TableCell sx={{ fontSize: '0.65rem'}} align="left">{formatCurrency(asset.cost)}</TableCell>
										<TableCell sx={{ fontSize: '0.65rem'}} align="center">{formatCurrency(asset.currentValue)}</TableCell>
										<TableCell sx={{ fontSize: '0.65rem'}} align="center">{formatCurrency(asset.avgPrice, 'SMALL')}</TableCell>
										<TableCell sx={{ fontSize: '0.65rem'}} align="center">{formatCurrency(asset.price, 'SMALL')}</TableCell>
										<TableCell sx={{ fontSize: '0.65rem', color: asset.return >= 0 ? "green" : "red"}} align="center">{asset.return.toFixed(2)}</TableCell>
										<TableCell sx={{ fontSize: '0.65rem', color: asset.changePercent >= 0 ? "green" : "red"}} align="center">{parseFloat(asset.changePercent).toFixed(2)}</TableCell>
										<TableCell sx={{ fontSize: '0.65rem'}} align="center">{(((asset.currentValue/total))*100).toFixed(2)}</TableCell>
										<TableCell sx={{ fontSize: '0.65rem'}} align="center">{formatCurrency(asset.dividends, 'SMALL')}</TableCell>
									</TableRow>
								)) : null }
							</TableBody>

						</Table>
					</TableContainer> */}
				</Stack>
			</CardContent>
		</Card>
	)
}

export default AssetListCard